<template>
  <v-slide-x-transition>
    <v-snackbar
      v-if="snackbarData.isSuccess && snackbarData.snackbarStatus"
      style="margin: auto; position: absoulute;"
      timeout="3250"
      class="transparent mr-5"
      v-model="snackbarData.snackbarStatus"
      color="background"
      right
      bottom
    >
      <div class="d-flex flex-row align-center">
        <lottie-player key="1" autoplay loop mode="normal" :src="check" style="width: 36px; height: 36px; margin-right: 12px; position: absoulute">
        </lottie-player>
        <div class="d-flex flex-column text-left">
          <span class="text-left text-h4 primary--text">Başarılı</span>
          <span class="text_color--text text-left text-h4">{{ snackbarData.snackbarText }} </span>
        </div>
      </div>
    </v-snackbar>
    <v-snackbar
      v-else-if="snackbarData.snackbarStatus"
      style="margin: auto; position: absoulute;"
      timeout="2000"
      class="transparent mr-5"
      v-model="snackbarData.snackbarStatus"
      color="background"
      right
      bottom
    >
      <div class="d-flex flex-row align-center">
        <lottie-player key="2" autoplay loop mode="normal" :src="error" style="width: 36px; height: 36px; margin-right: 12px; position: absoulute">
        </lottie-player>
        <div class="d-flex flex-column text-left">
          <span class="text-left text-h4 error--text">Başarısız</span>
          <span class="text_color--text text-left text-h4">{{ snackbarData.snackbarText }} </span>
        </div>
      </div>
    </v-snackbar>
  </v-slide-x-transition>
</template>

<script>
import "@lottiefiles/lottie-player";
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState(["snackbarData"]),
  },

  data: () => ({
    check: null,
    error: null,
  }),

  created() {
    this.$root.$refs.Snackbar = this;
    this.check = JSON.stringify(require("@/assets/gifs/check.json"));
    this.error = JSON.stringify(require("@/assets/gifs/error.json"));
  },

  methods: {
    ...mapActions(["addSnackBarAction", "loadSnackbarSuccess", "loadSnackbarError"]),

    async setSnackbarSuccess(message) {
      await this.loadSnackbarSuccess(message);
    },
    async setSnackbarError(message) {
      await this.loadSnackbarError(message);
    },
  },
};
</script>
